export default "__VITE_ASSET__C$FdKeiU__"